import React, { useState, useRef, useEffect } from 'react';
import XCloseIcon from '../../../images/svg/xCloseIcon';
import styles from './promotion.module.css';
import { promo } from '../../../images';
import Button from '../../button';
import { Link } from 'react-router-dom';

export default function Promotion({ onClose, promoData }) {
  return (
    <section className={styles["modal-shadow"]}  onClick={onClose}>
      <div className={styles["inner"]} onClick={(e)=>{e.stopPropagation()}}>
        <span className={styles["top_btn"]}>
          <XCloseIcon onClick={onClose} fill="white" />
        </span>
        <div className={styles['main']}>
          <div className={styles['textdiv']}>
            <div className={styles['tag']}>
              <p>{promoData.availabilityText}</p>
            </div>
            <div className={styles['heading']}>
              <p>
                {`${promoData.heading.text} `}
                <span className={styles['subtext']}>{promoData.heading.subtext}</span>
              </p>
            </div>
            <div className={styles['text']}>
              <p>
                {promoData.description}
              </p>
            </div>

            <div>
              <Link to={promoData.buttonUrl}>
                <Button className={styles['detailbtn']} variant='secondary' icon="blackArrow">
                  {promoData.buttonLabel}
                </Button>
              </Link>
            </div>
          </div>
          <div className={styles['image']}>
            <img src={promo} alt="promopic" />
          </div>
        </div>
      </div>
      <div className={styles.overlay} />
    </section>
  );
}
